import { createApp } from 'vue';
import sampleImageCarousel from '../../components/carousel/sample-image-carousel.vue';

document.addEventListener('DOMContentLoaded', () => {
	const app = createApp(sampleImageCarousel);
	app.mount('#sample-image-carousel');
});
